var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrescriptionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9799 0.546875C25.2332 0.762615 25.4958 0.968975 25.7303 1.1941C27.8877 3.34212 30.0358 5.49952 32.1932 7.64754C32.5308 7.97584 32.6809 8.33228 32.6809 8.81066C32.6715 13.6038 32.6716 18.397 32.6716 23.1902C32.6716 23.3215 32.6809 23.4622 32.6622 23.5935C32.6153 24.025 32.2776 24.3346 31.8649 24.3346C31.4428 24.3346 31.1145 24.0156 31.0769 23.5842C31.0676 23.4528 31.0676 23.3215 31.0676 23.1808C31.0676 18.7253 31.0676 14.2604 31.0676 9.80494C31.0676 9.64548 31.0676 9.48602 31.0676 9.27966C30.8987 9.27966 30.758 9.27966 30.6173 9.27966C29.2291 9.27966 27.8409 9.27966 26.4526 9.27966C24.9612 9.27966 23.9481 8.26662 23.9388 6.76582C23.9294 5.24626 23.9388 3.7267 23.9388 2.15086C23.7699 2.15086 23.6292 2.15086 23.4885 2.15086C16.6693 2.15086 9.85001 2.15086 3.02137 2.15086C2.19593 2.15086 1.90515 2.44164 1.90515 3.24832C1.90515 15.114 1.90515 26.9797 1.90515 38.8454C1.90515 39.6615 2.19593 39.9523 3.01199 39.9523C7.89897 39.9523 12.7859 39.9523 17.6729 39.9523C17.8042 39.9523 17.9449 39.9429 18.0763 39.9616C18.5077 39.9992 18.8173 40.3462 18.8173 40.7589C18.8173 41.1623 18.5171 41.4906 18.1044 41.5375C17.9637 41.5562 17.8136 41.5469 17.6635 41.5469C12.8047 41.5469 7.94587 41.5469 3.08703 41.5469C1.57685 41.5469 0.910867 41.0872 0.376207 39.6802C0.357447 39.6709 0.329307 39.6521 0.310547 39.6333C0.310547 27.2424 0.310547 14.8608 0.310547 2.46978C0.526287 1.91636 0.760787 1.36294 1.29545 1.02526C1.59561 0.837655 1.92391 0.706335 2.23345 0.546875C9.81249 0.546875 17.4009 0.546875 24.9799 0.546875ZM25.5615 3.42654C25.5709 3.41716 25.5427 3.43592 25.5427 3.45468C25.5427 4.50524 25.5334 5.56518 25.5334 6.61574C25.5334 7.35676 25.8429 7.6663 26.5745 7.6663C27.5595 7.6663 28.5537 7.6663 29.5386 7.6663C29.6324 7.6663 29.7356 7.64754 29.7637 7.64754C28.3755 6.24992 26.9685 4.83354 25.5615 3.42654Z",
    fill: "url(#paint0_linear_4064_3114)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7945 31.6115C39.3589 31.3489 41.3756 34.2754 41.3287 36.6205C41.2818 39.1718 39.2745 41.3761 36.7794 41.5543C34.153 41.7419 31.6767 39.9222 31.3671 36.8362C31.2358 36.9581 31.142 37.0519 31.0388 37.1457C30.007 38.1682 29.0034 39.2281 27.9434 40.2224C25.439 42.5767 21.3399 41.7326 20.008 38.5527C19.2107 36.658 19.4452 34.8101 20.8709 33.3093C23.0565 31.0018 25.3077 28.76 27.6058 26.5651C29.0034 25.2237 30.7481 24.9424 32.5584 25.5802C34.3781 26.218 35.485 27.55 35.7851 29.4635C35.8883 30.1483 35.7945 30.8799 35.7945 31.6115ZM30.6543 35.1009C31.5641 34.2286 32.5209 33.3562 33.4214 32.4276C34.1155 31.7147 34.35 30.8049 34.2187 29.8106C34.0498 28.5349 33.3557 27.6344 32.1926 27.156C31.0107 26.6683 29.8101 26.7714 28.8627 27.6438C27.8684 28.5443 27.0054 29.5948 26.1143 30.5422C27.5682 32.0055 29.1347 33.5813 30.6543 35.1009ZM24.7542 31.6397C23.9007 32.4933 23.0377 33.3281 22.2123 34.191C20.8803 35.598 20.8709 37.6241 22.1747 38.9373C23.4035 40.1755 25.439 40.3162 26.8272 39.0311C27.4369 38.4683 28.0091 37.868 28.5907 37.2958C28.9002 36.9957 29.2097 36.6861 29.5005 36.4047C27.9059 34.8007 26.3488 33.2343 24.7542 31.6397ZM35.5319 39.7815C35.5319 37.6523 35.5319 35.523 35.5319 33.3843C34.1905 33.5344 32.9711 35.0821 32.9899 36.6017C33.0086 38.1212 34.2093 39.6314 35.5319 39.7815ZM37.164 39.7909C38.5991 39.5564 39.7904 37.9899 39.7153 36.4985C39.6309 34.9414 38.4021 33.4406 37.164 33.3937C37.164 35.523 37.164 37.6429 37.164 39.7909Z",
    fill: "url(#paint1_linear_4064_3114)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4725 20.5722C12.5798 20.5722 9.4375 17.4111 9.4375 13.5184C9.44688 9.62572 12.6079 6.47404 16.5006 6.48342C20.384 6.4928 23.5356 9.65386 23.5356 13.5466C23.5356 17.4299 20.3746 20.5722 16.4725 20.5722ZM16.4725 18.9682C19.4553 18.987 21.941 16.5106 21.941 13.5278C21.941 10.5637 19.4929 8.10616 16.5194 8.07802C13.5459 8.05926 11.0509 10.545 11.0509 13.5278C11.0415 16.4919 13.499 18.9494 16.4725 18.9682Z",
    fill: "url(#paint2_linear_4064_3114)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7744 24.5784C17.5044 24.5784 15.2344 24.5784 12.9645 24.5784C12.2891 24.5784 11.8858 24.1 12.0734 23.5372C12.1766 23.2183 12.4111 23.0307 12.7487 22.9932C12.8801 22.9744 13.0114 22.9838 13.1521 22.9838C17.5701 22.9838 21.988 22.9838 26.406 22.9838C26.5092 22.9838 26.6218 22.9838 26.7249 22.9838C27.2033 23.0119 27.5504 23.3496 27.541 23.7905C27.5316 24.222 27.2033 24.5503 26.7437 24.5784C26.6218 24.5878 26.4998 24.5784 26.3873 24.5784C24.183 24.5784 21.9787 24.5784 19.7744 24.5784Z",
    fill: "url(#paint3_linear_4064_3114)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.829 29.0604C15.5252 29.0604 14.212 29.0698 12.9082 29.0604C12.261 29.0604 11.867 28.507 12.1015 27.9536C12.2422 27.6347 12.5048 27.4658 12.8613 27.4658C15.5064 27.4658 18.1422 27.4658 20.7874 27.4658C21.2751 27.4658 21.6128 27.8129 21.6128 28.2631C21.6128 28.7227 21.2658 29.0604 20.7499 29.0604C19.4367 29.0604 18.1328 29.0604 16.829 29.0604Z",
    fill: "url(#paint4_linear_4064_3114)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54253 24.5772C7.12043 24.5772 6.68895 24.5866 6.26685 24.5772C5.77909 24.5678 5.44141 24.2302 5.44141 23.7799C5.44141 23.3297 5.77909 22.992 6.26685 22.9826C7.12043 22.9732 7.97401 22.9732 8.82759 22.9826C9.30597 22.992 9.65303 23.3391 9.65303 23.7799C9.65303 24.2208 9.30597 24.5585 8.82759 24.5772C8.39611 24.5866 7.96463 24.5772 7.54253 24.5772Z",
    fill: "url(#paint5_linear_4064_3114)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56186 29.0616C7.13976 29.0616 6.70828 29.071 6.28618 29.0616C5.79842 29.0522 5.46074 28.7239 5.45136 28.2831C5.44198 27.8234 5.78904 27.4764 6.29556 27.467C7.13038 27.4576 7.97458 27.4576 8.8094 27.467C9.29716 27.4764 9.64422 27.8047 9.6536 28.2455C9.66298 28.6958 9.30654 29.0522 8.80002 29.0616C8.3873 29.071 7.97458 29.0616 7.56186 29.0616Z",
    fill: "url(#paint6_linear_4064_3114)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54214 31.9508C7.96424 31.9508 8.39572 31.9414 8.81782 31.9508C9.2962 31.9602 9.64326 32.3166 9.64326 32.7481C9.64326 33.1889 9.2962 33.536 8.80844 33.536C7.95486 33.5454 7.10128 33.5454 6.2477 33.536C5.75994 33.5266 5.43164 33.1796 5.43164 32.7387C5.43164 32.2885 5.76932 31.9695 6.25708 31.9414C6.28522 31.9414 6.31336 31.9414 6.3415 31.9414C6.74484 31.9508 7.14818 31.9508 7.54214 31.9508Z",
    fill: "url(#paint7_linear_4064_3114)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6202 32.758C13.6108 33.1989 13.2637 33.5459 12.8322 33.5459C12.4101 33.5459 12.0349 33.1801 12.0256 32.758C12.0162 32.3265 12.4101 31.942 12.851 31.9513C13.2919 31.9607 13.6202 32.3172 13.6202 32.758Z",
    fill: "url(#paint8_linear_4064_3114)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6927 12.7222C15.6927 12.028 15.6927 11.3808 15.6927 10.7242C15.6927 10.152 16.0304 9.77683 16.5088 9.79559C16.9778 9.80497 17.2873 10.1708 17.2873 10.7242C17.2873 11.3714 17.2873 12.028 17.2873 12.7222C18.019 12.7222 18.7225 12.7128 19.426 12.7222C19.8762 12.7315 20.2139 13.0974 20.2139 13.5195C20.2139 13.9134 19.9044 14.2605 19.501 14.3074C19.3697 14.3261 19.2384 14.3168 19.0977 14.3168C18.5161 14.3168 17.9252 14.3168 17.278 14.3168C17.278 15.0109 17.278 15.6862 17.278 16.3616C17.278 16.7274 17.1373 17.0182 16.809 17.1777C16.2837 17.4215 15.7021 17.0557 15.6834 16.446C15.6646 15.7519 15.6834 15.0672 15.6834 14.3261C14.9611 14.3261 14.267 14.3355 13.5822 14.3261C12.9632 14.3168 12.588 13.754 12.8225 13.2193C12.9725 12.8816 13.2539 12.7222 13.6198 12.7222C14.2951 12.7222 14.9611 12.7222 15.6927 12.7222Z",
    fill: "url(#paint9_linear_4064_3114)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4064_3114",
    x1: -6.1299,
    y1: 41.5492,
    x2: 46.4438,
    y2: 41.7058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0536E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E9ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4064_3114",
    x1: 15.2224,
    y1: 41.5687,
    x2: 50.5869,
    y2: 41.7468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0536E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E9ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4064_3114",
    x1: 6.63252,
    y1: 20.5722,
    x2: 29.5296,
    y2: 20.6586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0536E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E9ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4064_3114",
    x1: 8.9407,
    y1: 24.5826,
    x2: 34.1038,
    y2: 25.5027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0536E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E9ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4064_3114",
    x1: 10.1272,
    y1: 29.0646,
    x2: 25.678,
    y2: 29.4162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0536E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E9ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4064_3114",
    x1: 4.60346,
    y1: 24.5814,
    x2: 11.4431,
    y2: 24.6491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0536E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E9ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4064_3114",
    x1: 4.61502,
    y1: 29.0658,
    x2: 11.44,
    y2: 29.1332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0536E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E9ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4064_3114",
    x1: 4.59369,
    y1: 33.543,
    x2: 11.4333,
    y2: 33.6109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0536E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E9ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4064_3114",
    x1: 11.7081,
    y1: 33.5459,
    x2: 14.2982,
    y2: 33.5557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0536E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E9ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4064_3114",
    x1: 11.2673,
    y1: 17.254,
    x2: 23.3864,
    y2: 17.2998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0536E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E9ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptionIcon);
export default __webpack_public_path__ + "static/media/prescription-icon.511be3dacb90f26b9d1bfb9b058f20fc.svg";
export { ForwardRef as ReactComponent };